module.exports = __webpack_public_path__ + "static/media/l9.7821e1a7.jpg";